import SequenceMultipleCompare from './SequenceMultipleCompare';

export default SequenceMultipleCompare;